import ApiCall from "../../../../Apicall/ApiCall";

// The deal's payment stage on the Klargo backend (ContractPaymentAppService). The server owns
// every payment state; nothing here decides anything on its own.
const BASE = "/ContractPayment";

const unwrap = (response) => response?.data?.result ?? response?.data;

/** The server's error code (UserFriendlyException.Message), e.g. "paymentInstructionChanged". */
export function paymentErrorCode(error) {
  return error?.response?.data?.error?.message ?? null;
}

export const paymentApi = {
  getState: async (contractId) =>
    unwrap(await ApiCall({ url: `${BASE}/GetState`, method: "GET", params: { Id: contractId } })),

  confirmSwishNumber: async (contractId, swishNumber) =>
    unwrap(await ApiCall({ url: `${BASE}/ConfirmSwishNumber`, method: "POST", data: { contractId, swishNumber } })),

  getSwishInstruction: async (contractId) =>
    unwrap(await ApiCall({ url: `${BASE}/GetSwishInstruction`, method: "GET", params: { Id: contractId } })),

  getSwishQr: async (contractId) =>
    unwrap(await ApiCall({ url: `${BASE}/GetSwishQr`, method: "GET", params: { Id: contractId } })),

  reportPaid: async (contractId, method, instructionFingerprint = null) =>
    unwrap(await ApiCall({ url: `${BASE}/ReportPaid`, method: "POST", data: { contractId, method, instructionFingerprint } })),

  confirmReceived: async (contractId) =>
    unwrap(await ApiCall({ url: `${BASE}/ConfirmReceived`, method: "POST", data: { id: contractId } })),
};
